import { useEffect, useRef, useState } from "react";

const DEFAULT_COORDS = {
  lat: 12.9716,
  lng: 77.5946,
};

const GoogleMapPicker = ({ initialLat, initialLng, onChangeLocation }) => {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markerRef = useRef(null);
  

  const [coords, setCoords] = useState(null);

  // ✅ STEP 1: Decide initial coords (handles ALL cases)
  useEffect(() => {
    console.log("MAP LATLONG",initialLat,initialLng)
    if (coords) return; // run only once

    const lat = Number(initialLat);
    const lng = Number(initialLng);

    const validCoords =
      !isNaN(lat) && !isNaN(lng)
        ? { lat, lng } // ✅ Case 2.1 (Edit with values)
        : DEFAULT_COORDS; // ✅ Case 1 + Case 2.2

    setCoords(validCoords);
  }, [initialLat, initialLng, coords]);

  // ✅ STEP 2: Initialize map only once
  useEffect(() => {
    if (!coords || mapInstance.current) return;

    const updateCoords = (newCoords) => {
      setCoords(newCoords);
      onChangeLocation && onChangeLocation(newCoords);
    };

    const initMap = () => {
      const map = new window.google.maps.Map(mapRef.current, {
        center: coords,
        zoom: 13,
      });

      mapInstance.current = map;

      const marker = new window.google.maps.Marker({
        position: coords,
        map,
        draggable: true,
      });

      markerRef.current = marker;

      // --- ADDED AUTOCOMPLETE LOGIC START ---
      const input = document.getElementById("pac-input");
      console.log("Autocomplete initialized", input);
      const autocomplete = new window.google.maps.places.Autocomplete(input);
      
      // Bind autocomplete to map bounds so it suggests local places first
      autocomplete.bindTo("bounds", map);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (!place.geometry || !place.geometry.location) {
          console.log("No details available for input: '" + place.name + "'");
          return;
        }

        const newLocation = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };

        // Move map and marker to the searched location
        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(17);
        }
        
        marker.setPosition(place.geometry.location);
        updateCoords(newLocation);
      });
      // --- ADDED AUTOCOMPLETE LOGIC END --- 

      // click
      map.addListener("click", (e) => {
        const newCoords = {
          lat: e.latLng.lat(),
          lng: e.latLng.lng(),
        };
        marker.setPosition(newCoords);
        updateCoords(newCoords);
      });

      // drag
      marker.addListener("dragend", () => {
        const pos = marker.getPosition();
        updateCoords({
          lat: pos.lat(),
          lng: pos.lng(),
        });
      });
    };

    if (window.google?.maps) {
      initMap();
    } else {
      const interval = setInterval(() => {
        if (window.google?.maps) {
          initMap();
          clearInterval(interval);
        }
      }, 300);
    }
  }, [coords]);

  // ✅ STEP 3: send initial coords to parent (important)
  useEffect(() => {
    if (coords) {
      onChangeLocation && onChangeLocation(coords);
    }
  }, [coords]);

  if (!coords) return <div>Loading map...</div>;

  return (
    <div>
      <input
          id="pac-input"
          className="seller-form-control seller-form-control-alternative mb-2"
          type="text"
          placeholder="Search for location"
        />
        <div
          id="map"
          ref={mapRef}
          style={{ width: "100%", height: "300px", borderRadius: "12px" }}
        />
        <input
          type="text"
          className="seller-form-control seller-form-control-alternative mt-2"
          placeholder="Latitude"
          value={coords.lat || ""}
          readOnly
        />
        <input
          type="text"
          className="seller-form-control seller-form-control-alternative mt-2"
          placeholder="Longitude"
          value={coords.lng || ""}
          readOnly
        />
      </div>
      
  );
};

export default GoogleMapPicker;

